import { render, staticRenderFns } from "./F2FStatusChart.vue?vue&type=template&id=531fa074"
import script from "./F2FStatusChart.vue?vue&type=script&lang=js"
export * from "./F2FStatusChart.vue?vue&type=script&lang=js"
import style0 from "./F2FStatusChart.vue?vue&type=style&index=0&id=531fa074&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports